import type { ReactNode } from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface AnimatedHelperTextProps {
  children?: ReactNode;
  visible?: boolean;
  minHeight?: number | string;
  sx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}

export default function AnimatedHelperText({
  children,
  visible = false,
  minHeight = 20,
  sx,
  contentSx,
}: AnimatedHelperTextProps) {
  return (
    <Box
      component="span"
      sx={{
        display: "block",
        minHeight,
        overflow: "hidden",
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "block",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(-4px)",
          transition: "opacity 180ms ease, transform 220ms ease",
          willChange: "opacity, transform",
          ...contentSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
